var _desc, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLessonPlan(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 3.6.6")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.52 0 0 0.52 24 26)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {}
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -5.31 18.06)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-87.69, -103.06)",
    d: "m 83.38559 103.0618 c -0.0005 2.377 1.9263 4.305 4.3036 4.305 c 2.3773 0.001 4.3048 -1.926 4.3054 -4.303 c 0.0006 -2.377 -1.9263 -4.305 -4.3035 -4.3056 c -0.0007 0 -0.0013 0 -0.0019 0 c -2.3765 0.0006 -4.303 1.9266 -4.3036 4.3036 z m 6.7122 0 c 0.0006 1.33 -1.0774 2.409 -2.4077 2.41 c -1.3303 0 -2.409 -1.078 -2.4096 -2.408 c -0.0005 -1.33 1.0774 -2.409 2.4077 -2.41 c 0.0007 0 0.0013 0 0.0019 0 c 1.3289 0.002 2.4056 1.079 2.4077 2.408 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -5.38 27.85)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-87.62, -112.85)",
    d: "m 95.30279 111.1298 c -1.2369 -0.954 -2.6521 -1.65 -4.1623 -2.048 c -1.1398 -0.35 -2.3253 -0.529 -3.5177 -0.531 c -1.1907 0.018 -2.3737 0.197 -3.5167 0.531 c -1.4935 0.442 -2.901 1.134 -4.1624 2.048 c -0.5263 0.415 -0.8392 1.045 -0.8531 1.715 l 0 4.301 l 17.0625 0 l 0 -4.303 c -0.014 -0.67 -0.3258 -1.298 -0.8503 -1.713 z m -1.0427 4.12 l -13.2774 0 l 0 -2.37 c 0.0016 -0.096 0.0431 -0.188 0.1147 -0.253 c 1.0741 -0.77 2.2695 -1.355 3.5366 -1.731 c 0.9748 -0.284 1.9831 -0.437 2.9983 -0.454 c 0.9994 0.003 1.9928 0.154 2.948 0.448 l 0.073 0.021 c 1.259 0.329 2.4391 0.907 3.4703 1.701 c 0.073 0.056 0.1208 0.138 0.1327 0.229 l 0.0038 2.409 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 13.52 18.06)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-106.52, -103.06)",
    d: "m 102.21649 103.0618 c -0.001 2.377 1.926 4.305 4.303 4.305 c 2.377 0.001 4.305 -1.926 4.305 -4.303 c 0.001 -2.377 -1.926 -4.305 -4.303 -4.3056 c 0 0 -0.001 0 -0.001 0 c -2.377 0.0006 -4.303 1.9266 -4.304 4.3036 z m 6.713 0 c 0 1.33 -1.078 2.409 -2.408 2.41 c -1.33 0 -2.409 -1.078 -2.41 -2.408 c 0 -1.33 1.078 -2.409 2.408 -2.41 c 0 0 0.001 0 0.001 0 c 1.328 0.003 2.404 1.08 2.406 2.408 l 0.003 0 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 13.58 27.85)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-106.58, -112.85)",
    d: "m 114.26349 111.1298 c -1.237 -0.953 -2.652 -1.65 -4.162 -2.048 c -1.14 -0.35 -2.325 -0.529 -3.517 -0.531 c -1.191 0.018 -2.374 0.197 -3.517 0.531 c -1.4938 0.442 -2.9013 1.134 -4.1626 2.048 c -0.5264 0.415 -0.8393 1.045 -0.8531 1.715 l 0 4.301 l 17.0627 0 l 0 -4.303 c -0.014 -0.67 -0.327 -1.298 -0.851 -1.713 z m -1.043 4.12 l -13.271 0 l 0 -2.37 c 0.002 -0.096 0.0439 -0.188 0.1157 -0.253 c 1.0736 -0.77 2.2683 -1.355 3.5353 -1.731 c 0.975 -0.284 1.983 -0.437 2.999 -0.454 c 0.999 0.003 1.993 0.154 2.949 0.448 l 0.073 0.021 c 1.258 0.329 2.438 0.907 3.469 1.701 c 0.073 0.056 0.121 0.138 0.133 0.229 l -0.003 2.409 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 32.48 18.06)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-125.48, -103.06)",
    d: "m 121.17449 103.0618 c -0.001 2.377 1.926 4.305 4.303 4.305 c 2.378 0.001 4.305 -1.926 4.306 -4.303 c 0 -2.377 -1.926 -4.305 -4.304 -4.3056 c 0 0 0 0 -0.001 0 c -2.376 0.0006 -4.303 1.9266 -4.304 4.3036 z m 6.712 0 c 0.001 1.33 -1.077 2.409 -2.408 2.41 c -1.33 0 -2.409 -1.078 -2.409 -2.408 c -0.001 -1.33 1.077 -2.409 2.407 -2.41 c 0.001 0 0.002 0 0.002 0 c 1.329 0.002 2.406 1.079 2.408 2.408 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 32.54 27.85)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-125.54, -112.85)",
    d: "m 133.22449 111.1298 c -1.237 -0.954 -2.652 -1.65 -4.163 -2.048 c -1.139 -0.35 -2.324 -0.529 -3.516 -0.531 c -1.191 0.018 -2.375 0.197 -3.518 0.531 c -1.493 0.442 -2.9 1.134 -4.161 2.048 c -0.527 0.415 -0.84 1.045 -0.854 1.715 l 0 4.301 l 17.063 0 l 0 -4.303 c -0.014 -0.67 -0.326 -1.298 -0.851 -1.713 z m -1.043 4.12 l -13.271 0 l 0 -2.37 c 0.002 -0.096 0.043 -0.188 0.115 -0.253 c 1.074 -0.77 2.269 -1.355 3.537 -1.731 c 0.974 -0.284 1.983 -0.437 2.998 -0.454 c 0.999 0.003 1.993 0.154 2.948 0.448 l 0.073 0.021 c 1.259 0.329 2.439 0.907 3.47 1.701 c 0.073 0.056 0.121 0.138 0.133 0.229 l -0.003 2.409 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 4.57 -18.09)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-97.57, -66.91)",
    d: "m 71.50349 50.7917 c 0 -1.0471 0.8488 -1.8958 1.8958 -1.8958 l 48.3442 0 c 1.047 0 1.895 0.8487 1.895 1.8958 l 0 32.2292 c 0 1.0471 -0.848 1.8958 -1.895 1.8958 l -32.0751 0 l -1.1479 1.8959 l 33.223 0 c 2.094 0 3.791 -1.6977 3.791 -3.7917 l 0 -32.2292 c 0 -2.094 -1.697 -3.7917 -3.791 -3.7917 l -48.3442 0 c -2.094 0 -3.7916 1.6977 -3.7916 3.7917 l 0 3.823 c 0.6431 0.0437 1.2792 0.1607 1.8958 0.3488 l 0 -4.1718 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -14.41 -5.98)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-78.59, -79.02)",
    d: "m 80.88789 83.1451 c 0.3645 0.0439 0.7217 -0.1268 0.9166 -0.438 l 4.0685 -6.4894 c 0.4445 -0.7037 1.3754 -0.9139 2.0791 -0.4693 c 0.024 0.0151 0.0476 0.031 0.0707 0.0475 c 0.655 0.5292 0.792 1.4733 0.3148 2.1669 l -4.9662 8.2023 c -0.5057 0.8337 -1.5745 1.1275 -2.4352 0.6693 c -0.4623 -0.2461 -1.0364 -0.0709 -1.2825 0.3914 c -0.2461 0.4623 -0.0708 1.0365 0.3915 1.2826 c 1.749 0.9306 3.9204 0.3332 4.9472 -1.3612 l 4.9566 -8.1862 c 0.7766 -1.1998 0.7523 -2.7497 -0.0616 -3.9244 l 12.0211 -12.2462 c 0.362 -0.379 0.347 -0.979 -0.032 -1.3401 c -0.3714 -0.3539 -0.957 -0.3481 -1.3212 0.0131 l -12.1723 12.3987 c -0.6017 -0.2401 -1.2597 -0.3023 -1.8958 -0.1791 c -0.9171 0.1835 -1.7195 0.7337 -2.2209 1.5233 l -2.9993 4.786 l -1.7508 -5.297 l -0.0616 -0.1459 c -1.4105 -3.2381 -4.7708 -3.8514 -10.4688 -3.8514 c -5.6979 0 -9.0545 0.6133 -10.4763 3.8608 c 0 0 -0.038 0.0797 -0.0569 0.1337 c -0.0249 0.0647 -0.0449 0.1313 -0.0597 0.1991 l -3.3092 18.0909 c -0.3953 1.6818 0.6476 3.3656 2.3294 3.7609 c 0.0761 0.0179 0.1528 0.0329 0.23 0.045 l 0.2843 0.0446 c 0.0496 0.0079 0.0997 0.0117 0.1498 0.0113 c 0.5233 -0.0162 0.9343 -0.4535 0.9181 -0.9768 c -0.0139 -0.4461 -0.337 -0.8221 -0.7759 -0.9029 l -0.2844 -0.0455 c -0.3389 -0.0521 -0.6403 -0.2444 -0.8304 -0.5299 c -0.1975 -0.2992 -0.2579 -0.6686 -0.1658 -1.0152 l 3.2997 -18.035 l 0.0104 -0.0266 c 0.7725 -1.764 2.3925 -2.7186 8.7369 -2.7186 c 6.3444 0 7.9625 0.9546 8.7294 2.7025 l 2.3869 7.2042 c 0.1148 0.349 0.421 0.6002 0.7858 0.6446 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -23.87 15.28)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-69.13, -100.28)",
    d: "m 75.29519 79.6273 c -0.5236 0 -0.9479 0.4244 -0.9479 0.948 l 0 38.4665 l -4.2657 0 l 0 -23.5577 l -1.8958 0 l 0 23.5577 l -4.2656 0 l 0 -38.4665 c 0 -0.5236 -0.4244 -0.948 -0.9479 -0.948 c -0.5236 0 -0.948 0.4244 -0.948 0.948 l 0 40.3625 l 14.2188 0 l 0 -40.3625 c 0 -0.5236 -0.4244 -0.948 -0.9479 -0.948 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -24.01 -21.89)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-68.99, -63.11)",
    d: "m 68.98579 68.8021 c 3.1411 0 5.6875 -2.5464 5.6875 -5.6875 c 0 -3.1411 -2.5464 -5.6875 -5.6875 -5.6875 c -3.1411 0 -5.6875 2.5464 -5.6875 5.6875 c 0.0037 3.1396 2.5479 5.6838 5.6875 5.6875 z m 0 -9.4791 c 2.0941 0 3.7917 1.6976 3.7917 3.7916 c 0 2.0941 -1.6976 3.7917 -3.7917 3.7917 c -2.094 0 -3.7916 -1.6976 -3.7916 -3.7917 c 0 -2.094 1.6976 -3.7916 3.7916 -3.7916 z",
    strokeLinecap: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLessonPlan);
export default __webpack_public_path__ + "static/media/lesson-plan.8dcc6b91eb162d7a58d8866225316041.svg";
export { ForwardRef as ReactComponent };